// Share URLs always point at the production web app — the user wants
// recipients to land on app.getdub.com, not the staging Render host or
// a Capacitor-internal scheme. Path/search/hash from the current
// location are preserved so the destination route resolves correctly.
const PROD_APP_HOST = 'app.getdub.com'

export function getShareUrl() {
  if (typeof window === 'undefined') return undefined
  const { pathname, search, hash } = window.location
  return `https://${PROD_APP_HOST}${pathname}${search}${hash}`
}
